export default __webpack_public_path__ + "static/media/category-society.d0c6b018.jpg";